import AboutMe from '@/_components/AboutMe'
import Banner from '@/_components/Banner'
import ConnectMe from '@/_components/ConnectMe'
import Feature from '@/_components/Feature'
import { DEFAULT_DESCRIPTION, DEFAULT_TITLE, usePageSeo } from '@/lib/seo'
import React from 'react'
export default function Home() {
    usePageSeo({
        title: DEFAULT_TITLE,
        description: DEFAULT_DESCRIPTION,
        keywords: ['Tuhin Kairi', 'full-stack developer portfolio', 'AI engineer portfolio', 'React projects', 'case studies', 'system design'],
        jsonLd: {
            '@context': 'https://schema.org',
            '@type': 'Person',
            name: 'Tuhin Kairi',
            jobTitle: 'Full-Stack Developer and AI Engineer',
            description: DEFAULT_DESCRIPTION,
            email: 'mailto:tuhinkairii@gmail.com',
            sameAs: ['https://github.com/tuhinkairi', 'https://www.linkedin.com/in/tuhinkairi/', 'https://medium.com/@tuhinkairi'],
        },
    })

    return (
        <section className="relative tracking-wider sm:px-6">
            <main className="container mx-auto px-4 pt-28 sm:px-5 sm:pt-32 lg:px-0 lg:pt-24 ">
                <Banner />
                <hr className="border-border" />
                <section id="feature-work" className="scroll-mt-10">
                    <Feature />
                </section>
                <hr className="border-border" />
                <section id="about" className="scroll-mt-10">
                    <AboutMe />
                </section>
                <hr className="border-border" />
                <section id="connect" className="scroll-mt-10">
                    <ConnectMe />
                </section>
                <hr className="border-border" />
            </main>
        </section>
    )
}
